import PostMessageProcessor from './processor';
import store from '/bubble-button/src/redux/store';

import actionSetChatIsOpen from '/bubble-button/src/redux/actions/chat/actionSetChatIsOpen';
import actionSetChatIsClosed from '/bubble-button/src/redux/actions/chat/actionSetChatIsClosed';
import actionSetTotalUnreadEntries from '/bubble-button/src/redux/actions/totalUnreadEntries/actionSetTotalUnreadEntries';
import actionSetCustomization from '/bubble-button/src/redux/actions/customization/actionSetCustomization';
import actionSetCompany from '/bubble-button/src/redux/actions/company';

PostMessageProcessor.register('openState', function(isOpen) {
    if(isOpen){
        store.dispatch(actionSetChatIsOpen());
    }else{
        store.dispatch(actionSetChatIsClosed());
    }
});

PostMessageProcessor.register('totalUnreadEntries', function(payload) {
    if(!store) throw 'no store error';
    const totalUnreadEntries = payload;
    store.dispatch(actionSetTotalUnreadEntries(totalUnreadEntries));
});

PostMessageProcessor.register('initializeData', function(payload) {
    store.dispatch(actionSetCustomization(payload.features_payload.customization));
    store.dispatch(actionSetCompany(payload.company));
});



// WEBPACK FOOTER //
// ./postmessage/on.js